<div class="main-group-container">
  @if (!selectedStudent) {
    <div class="student-list-container tw:-mx-4">
      <group-student-list [includeContainerGutter]="includeContainerGutter" [clientId]="clientId" (studentSelected)="studentSelected($event)"></group-student-list>
    </div>
  }
  @if (selectedStudent) {
    <div class="student-info-container">
      <group-student-info [student]="selectedStudent" (backToStudents)="showStudentList()"></group-student-info>
    </div>
  }
</div>